import React from "react";
import { Card, FlexRow, Field, PrimaryButton } from "./styledComponents";

function SwapCard({ swap, onChangeSwap, onSwap }) {
  return (
    <Card>
      <h3>Swap</h3>
      <p style={{ color: "#94a3b8", fontSize: 12, marginTop: 4 }}>
        Swap rapidi tra asset custodiati in Virtual e On-chain Wallet.
      </p>
      <FlexRow gap={16} style={{ marginTop: 10 }}>
        <Field>
          <label>From</label>
          <select
            value={swap.from}
            onChange={(e) => onChangeSwap({ ...swap, from: e.target.value })}
          >
            <option value="CTY">CTY</option>
            <option value="USDT">USDT</option>
            <option value="USDC">USDC</option>
            <option value="BTC">BTC</option>
          </select>
        </Field>
        <Field>
          <label>To</label>
          <select value={swap.to} onChange={(e) => onChangeSwap({ ...swap, to: e.target.value })}>
            <option value="USDT">USDT</option>
            <option value="CTY">CTY</option>
            <option value="USDC">USDC</option>
            <option value="BTC">BTC</option>
          </select>
        </Field>
        <Field>
          <label>Amount</label>
          <input
            value={swap.amount}
            onChange={(e) => onChangeSwap({ ...swap, amount: e.target.value })}
          />
        </Field>
      </FlexRow>
      <PrimaryButton style={{ marginTop: 12 }} onClick={onSwap}>
        Preview Swap
      </PrimaryButton>
    </Card>
  );
}

export default SwapCard;

